import React, { useEffect, useState } from 'react'
import { Route } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { authService } from 'modules/auth'
import {
  COOKIE_INTEGRATION_BW_CENTRAL,
  COOKIE_INTEGRATION_NAME,
  LOCALSTORAGE_TOKEN_NAME
} from 'modules/auth/auth.constants'
import { useSelector } from 'store/redux.store'
import { getCluster } from 'modules/user'
import { Loader } from 'components/loader'
import { PrivateErrorBoundary } from 'components/error'
import { useAddUserIdOnSurvicate } from 'hooks/use-add-user-id-on-survicate'
import { useFetchIsFrom } from 'hooks/use-fetch-is-from'

import Cookies from 'js-cookie'
import { usePlatformManager } from 'src/components/structure/platform-manager.context'

interface IProps {
  component: any
  exact?: boolean
  path: string | string[]
}

const PrivateBootstrap = (props: IProps) => {
  const [isLoading, setIsLoading] = useState(true)
  const { user } = useSelector(state => state)
  const dispatch = useDispatch()
  const Component = props.component
  const localToken = localStorage.getItem(LOCALSTORAGE_TOKEN_NAME)
  const cookieTobeUsedAsValue = Cookies.get(COOKIE_INTEGRATION_BW_CENTRAL) || Cookies.get(COOKIE_INTEGRATION_NAME)
  const { isPlatformPath } = usePlatformManager()

  useEffect(() => {
    if (cookieTobeUsedAsValue && localToken) {
      return
    }

    authService.login()
  }, [])

  useEffect(() => {
    setIsLoading(!user && !isPlatformPath)
  }, [user, isPlatformPath])

  useEffect(() => {
    if (user && !user.cluster) {
      dispatch(getCluster())
    }
  }, [user])

  useFetchIsFrom()
  useAddUserIdOnSurvicate()

  return isLoading ? (
    <Loader />
  ) : (
    <PrivateErrorBoundary>
      <Component />
    </PrivateErrorBoundary>
  )
}

const PrivateRoute = (props: IProps): JSX.Element => (
  <Route exact={props.exact} path={props.path} render={() => <PrivateBootstrap {...props} />} />
)

export default PrivateRoute
